import { all, fork, call, put, takeLatest } from 'redux-saga/effects'
import history from '../../history'
import { constants } from '../modules/templatesActions'
import * as api from '../api/template'

function* fetchTemplates(action) {
  try {
    const payload = yield call(api.getTemplatesList, action.templateType)

    yield put({ type: constants.TEMPLATES_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.TEMPLATES_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* templatesRefresh() {
  yield takeLatest(constants.TEMPLATES_REFRESH.ACTION, fetchTemplates)
}

function* createTemplate(action) {
  try {
    const payload = {
      template_type: action.templateType,
      content: action.content,
      estimate_groups: action.estimateGroups,
      estimate_items: action.estimateItems,
      estimate_counts: action.estimateCounts,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      estimateSections: action.estimateSections,
      proposalSections: action.proposalSections,
      milestones: action.milestones,
      paymentSchedule: action.paymentSchedule
    }

    yield call(api.createTemplate, payload)
    yield put({ type: constants.CREATE_NEW_TEMPLATE.SUCCESS, payload })
    yield call(history.push, `/templates/${action.templateType}/`)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_NEW_TEMPLATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateTemplate() {
  yield takeLatest(constants.CREATE_NEW_TEMPLATE.ACTION, createTemplate)
}

function* createTemplateWithAttachment(action) {
  try {
    yield call(api.createTemplateWithAttachment, action.formData)
    yield put({ type: constants.CREATE_NEW_TEMPLATE_WITH_ATTACHMENT.SUCCESS })
    yield call(history.push, `/templates/form/`)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_NEW_TEMPLATE_WITH_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateTemplateWithAttachment() {
  yield takeLatest(
    constants.CREATE_NEW_TEMPLATE_WITH_ATTACHMENT.ACTION,
    createTemplateWithAttachment
  )
}

function* saveTemplateWithAttachment(action) {
  try {
    yield call(api.saveTemplateWithAttachment, action)
    yield put({ type: constants.SAVE_TEMPLATE_WITH_ATTACHMENT.SUCCESS })
    yield call(history.push, `/templates/form/`)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SAVE_TEMPLATE_WITH_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchSaveTemplateWithAttachment() {
  yield takeLatest(constants.SAVE_TEMPLATE_WITH_ATTACHMENT.ACTION, saveTemplateWithAttachment)
}

function* saveTemplate(action) {
  try {
    const payload = {
      template_id: action.templateId,
      template_type: action.templateType,
      content: action.content,
      estimate_groups: action.estimateGroups,
      estimate_items: action.estimateItems,
      estimate_counts: action.estimateCounts,
      estimateSections: action.estimateSections,
      proposalSections: action.proposalSections,
      milestones: action.milestones,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      paymentSchedule: action.paymentSchedule
    }

    yield call(api.saveTemplate, payload)
    yield put({ type: constants.UPDATE_SAVED_TEMPLATE.SUCCESS, payload })
    yield call(history.push, `/templates/${action.templateType}/`)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_SAVED_TEMPLATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchSaveTemplate() {
  yield takeLatest(constants.UPDATE_SAVED_TEMPLATE.ACTION, saveTemplate)
}

function* deleteTemplate(action) {
  try {
    yield call(api.deleteTemplate, action)
    yield put({ type: constants.DELETE_SAVED_TEMPLATE.SUCCESS, action })
    yield call(history.push, `/templates/${action.templateType}/`)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_SAVED_TEMPLATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteTemplate() {
  yield takeLatest(constants.DELETE_SAVED_TEMPLATE.ACTION, deleteTemplate)
}

function* getTemplateById(action) {
  try {
    const payload = yield call(api.getTemplateById, action)
    yield put({ type: constants.LOAD_SAVED_TEMPLATE.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LOAD_SAVED_TEMPLATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetTemplateById() {
  yield takeLatest(constants.LOAD_SAVED_TEMPLATE.ACTION, getTemplateById)
}

export function* rootSaga() {
  yield all([
    fork(templatesRefresh),
    fork(watchCreateTemplate),
    fork(watchGetTemplateById),
    fork(watchSaveTemplate),
    fork(watchDeleteTemplate),
    fork(watchCreateTemplateWithAttachment),
    fork(watchSaveTemplateWithAttachment)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/templatesSaga.js